export default __webpack_public_path__ + "static/media/trust.397ef93e.jpeg";